module.exports = __webpack_public_path__ + "img/lawn, meadow.9569fa4c.jpg";